var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ZDFPlayerInstance",staticClass:"b-zdfplayer zdfplayer_ zdfplayer_core/Player",attrs:{"data-jsb":_vm.jsb}})}
var staticRenderFns = []

export { render, staticRenderFns }